import { render, staticRenderFns } from "./RedGreen.vue?vue&type=template&id=fbebcb24&"
import script from "./RedGreen.vue?vue&type=script&lang=js&"
export * from "./RedGreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports